import { Table as TanstackTable } from '@tanstack/react-table'
import { ComponentProps } from 'react'

import { TableHeaderRow } from './TableHeaderRow'
import { Table } from '../..'

type TableHeaderProps = {
    table: TanstackTable<unknown>
} & Pick<
    ComponentProps<typeof Table>,
    'style' | 'onTableColumnHeaderClick' | 'getColumnSorting'
>

export const TableHeader: React.FC<TableHeaderProps> = ({
    table,
    onTableColumnHeaderClick,
    getColumnSorting,
    style,
}) => {
    return (
        <thead className="sticky top-0 z-30">
            {table.getHeaderGroups().map((headerGroup) => (
                <TableHeaderRow
                    onTableColumnHeaderClick={onTableColumnHeaderClick}
                    getColumnSorting={getColumnSorting}
                    key={headerGroup.id}
                    headerGroup={headerGroup}
                    table={table}
                    style={style}
                />
            ))}
        </thead>
    )
}
